import { Link } from "react-router-dom"
import { useLangUrl } from "../../utilities/useLangUrl";

export default function SeeMoreLink(props) {
    const langUrl = useLangUrl();

    return (
        <Link className="btn btn-masar btn-light-beige" to={`${langUrl}${props.linkTo}`}>{props.linkValue}</Link>
    )
}
